import { ActionItem, LeaseLifecycle, Unit } from '@urbanmix-tech/shared-js';
import { ActionGroupList } from './TrackerActionGroupList';
import type { ColorScaleOptions } from './BuildingVisualizers';

import {
  setApartmentData,
  setHoveredActionItem,
  setVisualizer,
  setSelectedUnit,
  setHighlightedUnits,
  setHoveredUnitId,
} from '@/features/project/projectSlice';
import { ColorGradientVisualizer, Visualizer } from '@urbanmix-tech/um-embedded';
import { useDispatch, useSelector } from 'react-redux';
import { act, useEffect, useState } from 'react';
import { convertPseudoDateToRealDate } from '@/helpers/common';
import { StateVisualizer } from './BuildingVisualizers';
import { visualizeByDueDate, visualizeByLeaseRenewalState } from '@/processes/AnalyzeUnits';
import { CustomReport, CustomReportTabContent } from './CustomReportTabContent';
import { CustomAggregatedReportTabContent } from './CustomAggregatedReportTabContent';
import { LeaseReportTabContent } from './reports/LeaseReportTabContent';
import { LeaseAnalysisTabContent } from './LeaseAnalysisTabContent';

import { demoData, report1,report2 } from './demoCSVData';
import { Button, FormControl, MenuItem, Select } from '@mui/material';
import { ProcessTimelineTabContent } from './ProcessTimelineTabContent';

type ReportsTabContentProps = {
  actionItems: ActionItem[];
  onBuildingDataChange?: (data: Record<string, any>) => void;
};

export function ReportsTabContent({
  actionItems,  
  onBuildingDataChange,
}: ReportsTabContentProps) {

  

  const dispatch = useDispatch();

  const [selectedScale, setSelectedScale] = useState<ColorScaleOptions>('default');

  const rentroll : CustomReport = {
    name: "Rent Roll",
    data: demoData,
    columns: [
      {
        label: 'Unit',        
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Tags',        
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Status',        
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Rent',        
        kind: 'currency',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      }
    ]
  }

  const aggregated: CustomReport = {
    name: "Upcoming Week",
    data: report2,
    aggregate: ['Event'],
  }

  const units: Unit[] = useSelector((state: any) => state.project.projectUnits) || [];
  // const leases = useSelector((state: any) => state.project.projectLeases) || [];
  const hoveredUnitId: string | null = useSelector((state: any) => state.project.hoveredUnitId);

  const [report, setReport] = useState<CustomReport>(aggregated);
  const [currentView, setCurrentView] = useState<'rentroll' | 'upcoming' | 'lease' | 'leaseAnalysis' | 'processTimeline'>('upcoming');



  return (
    <>
      {/* <div className="flex flex-row gap-4">
        <button onClick={() => setReport(rentroll)}>Rent Roll</button>
        <button onClick={() => setReport(aggregated)}>Upcoming Week</button>
      </div> */}
      <div className='w-full flex flex-col gap-4'>
      <div className="flex flex-row gap-4 flex-0 justify-start">
      <FormControl>
            <Select
              value={selectedScale}
              onChange={(e) => {
                setSelectedScale(e.target.value as ColorScaleOptions);
              }}
              label="Color Scale"
              size="xs"
              variant="standard"
            >
              <MenuItem value="blues">Blues</MenuItem>
              <MenuItem value="default">Green to Maroon</MenuItem>
              <MenuItem value="purpleToYellow">Purple to Yellow</MenuItem>
              <MenuItem value="tealToMagenta">Teal to Magenta</MenuItem>
              <MenuItem value="earthTones">Earth Tones</MenuItem>
              <MenuItem value="rainbow">Rainbow</MenuItem>
              <MenuItem value="pastel">Pastel</MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={() => {
              setReport(rentroll);
              setCurrentView('rentroll');
            }}
            variant={currentView === 'rentroll' ? 'contained' : 'outlined'}
          >
            Rent Roll
          </Button>
          <Button
            onClick={() => {
              setReport(aggregated);
              setCurrentView('upcoming');
            }}
            variant={currentView === 'upcoming' ? 'contained' : 'outlined'}
          >
            Upcoming Week
          </Button>
          <Button
            onClick={() => setCurrentView('lease')}
            variant={currentView === 'lease' ? 'contained' : 'outlined'}
          >
            Lease Report
          </Button>
          <Button
            onClick={() => setCurrentView('leaseAnalysis')}
            variant={currentView === 'leaseAnalysis' ? 'contained' : 'outlined'}
          >
            Lease Analysis
          </Button>
          <Button
            onClick={() => setCurrentView('processTimeline')}
            variant={currentView === 'processTimeline' ? 'contained' : 'outlined'}
          >
            Process Timeline
          </Button>
              </div>
              <div className='flex-grow'>
                {currentView === 'lease' ? (
                  <LeaseReportTabContent />
                ) : currentView === 'leaseAnalysis' ? (
                  <LeaseAnalysisTabContent
                    units={units}
                    actionItems={actionItems}
                    hoveredUnitId={hoveredUnitId}
                    onSelectUnit={(unitId) => {
                      if (unitId) dispatch(setSelectedUnit({ apartmentId: unitId }));
                    }}
                    onHoverUnit={(unitId) => {
                      dispatch(setHoveredUnitId(unitId));
                    }}
                    onLeaseUpdated={() => {
                      // Lease data will automatically refresh via Redux subscription
                    }}
                  />
                ) : currentView === 'processTimeline' ? (                  
                  <ProcessTimelineTabContent units={units} onHoverUnit={() => {}} onSelectUnit={() => {}} actionItems={[]} hoveredUnitId={""}/>
                ) :  report.aggregate ? (
                  <CustomAggregatedReportTabContent
                    report={report}
                    onHoverUnit={(unitId) => {
                      dispatch(setHoveredUnitId(unitId));
                    }}
                    hoveredUnitId={null}
                    onSelectUnit={(unit) => {}}
                    colorScale={selectedScale}
                  />
                ) : (
                  <CustomReportTabContent
                    report={report}
                    onHoverUnit={(unitId) => {
                      dispatch(setHoveredUnitId(unitId));
                    }}
                    hoveredUnitId={null}
                    onSelectUnit={(unit) => {}}
                    colorScale={selectedScale}
                  />
                )}
                </div>
      </div>
    </>
  );
}

